"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductList = exports.productListContext = exports.ProductListProvider = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-explicit-any -- needed for generic type */

const productListContext = exports.productListContext = /*#__PURE__*/(0, _react.createContext)({
  items: []
});
const ProductListProvider = ({
  value,
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(productListContext.Provider, {
  value: value,
  children: children
});
exports.ProductListProvider = ProductListProvider;
const useProductList = () => (0, _react.useContext)(productListContext);
exports.useProductList = useProductList;
